import { useApolloClient } from '@apollo/client';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import {
  FindMatchingAccommodationCatalogPropertyDocument,
  FindMatchingAccommodationCatalogPropertyPayload,
  FindMatchingAccommodationCatalogPropertyQuery,
} from '@graphql/generated';

export const useFindMatchingAccommodationCatalogProperty = () => {
  const client = useApolloClient();

  const findMatchingAccommodationCatalogProperty = useEventCallback((payload: FindMatchingAccommodationCatalogPropertyPayload) => {
    return client.query<FindMatchingAccommodationCatalogPropertyQuery>({
      query: FindMatchingAccommodationCatalogPropertyDocument,
      variables: { payload },
      fetchPolicy: 'cache-first',
    });
  });

  return { findMatchingAccommodationCatalogProperty };
};
